import 'core-js';
import 'regenerator-runtime/runtime';
import 'whatwg-fetch';
import 'custom-event-polyfill';
